import { Autocomplete, TextField } from "@mui/material";
import FormSection from "../../../../../Components/Forms/FormSection/form-section";
import { SectionGlobalProps } from "../settings-global";
import { produce } from "immer";
import { useEffect } from "react";
import { billingService } from "../../../../../Core/Api/services";
import React from "react";
import { DbSubscriptionOfferInfos } from "../../../../../Core/Api/Types/db-subscription-offer-infos";
import { BillingData } from "../../../../../Core/Api/Types/db-platform-infos";
import { useTranslation } from "react-i18next";

const SettingsGlobalSectionBilling = (props: SectionGlobalProps) => {
  const { t } = useTranslation();
  const { platformInfos, setPlatformInfos } = props;

  const [offers, setOffers] = React.useState<DbSubscriptionOfferInfos[]>([]);

  const enabled = platformInfos.billingData?.offerId ? true : false;

  useEffect(() => {
    billingService.ListSubscriptionOffers().then((response) => {
      if (response.success) setOffers(response.offers ?? []);
    });
  }, []);

  return (
    <FormSection
      title={enabled ? t("form:section.title.billingEnabled") : t("common:billing")}
      status="todo"
      sx={{ mb: 2 }}
    >
      <Autocomplete
        value={offers.find((x) => x.id === platformInfos.billingData?.offerId) ?? null}
        onChange={(e, value: any) =>
          setPlatformInfos(
            produce((draft) => {
              if (!draft.billingData) draft.billingData = new BillingData();

              if (value) draft!.billingData.offerId = value.id as number;
              else draft!.billingData = null;
            })
          )
        }
        options={offers}
        disabled={enabled}
        getOptionLabel={(option) => option.name}
        sx={{ width: "100%" }}
        id={"mode"}
        renderInput={(params) => (
          <TextField sx={{ mt: "-24px" }} placeholder={t("field:placeholder.selectOptionalBillingPlan")} {...params} />
        )}
      />
    </FormSection>
  );
};

export default SettingsGlobalSectionBilling;
